<template>
  <v-list two-line subheader>


    <v-list-item v-for="item in fields" :key="item.count">
      <v-list-item-content>
        <v-list-item-title>{{item.title}}</v-list-item-title>
         <v-list-item-subtitle>{{ doc[item.model] }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>


  </v-list>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AdminPlaneShow",
  data() {
    return {
      doc: {},
      fields: [
        {
          title: "Title",
          count: 1,
          model: "title",
        },
         {
          title: "Flag",
          count: 2,
          model: "flag",
        },
       {
          title: "Strapline",
          count: 3,
          model: "concept",
        },
        {
          title: "Description",
          count: 4,
          model: "description",
        },
        {
          title: "Promise",
          count: 5,
          model: "promise",
        },
        {
          title: "Justification",
          count: 6,
          model: "justification"
        },
        {
          title: "Pillars",
          count: 7,
          model: "pillars"
        }
       ]
    };
  },
  created() {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate (to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
};
</script>
